




















































































// App Style
import '@/assets/css/base.css';
import CustomStyle from '@/components/CustomStyle.vue';
import Enrichment from '@/components/Enrichment.vue';
import Error from '@/components/Error.vue';
import PreEnrichment from '@/components/PreEnrichment.vue';
import PrivacyLinks from '@/components/PrivacyLinks.vue';
// Components
import ProgressTimer from '@/components/ProgressTimer.vue';
import SandBox from '@/components/SandBox.vue';
import SoluCXFooter from '@/components/SoluCXFooter.vue';
import Customer from '@/models/Customer';
import SurveyState from '@/models/enums/SurveyState';
import SurveyStatus from '@/models/enums/SurveyStatus';
import ClassItem from '@/models/interfaces/ClassItem';
import ClassItemRate from '@/models/interfaces/ClassItemRate';
import Instance from '@/models/interfaces/Instance';
import JourneyParameters from '@/models/interfaces/JourneyParameters';
// Models
import RatingSubmitResponse from '@/models/interfaces/RatingSubmitResponse';
import SurveySettings from '@/models/interfaces/SurveySettings';
import TabletStatus from '@/models/interfaces/TabletStatus';
import RedirectQueryStringObject from '@/models/RedirectQueryStringObject';
import SurveyAnswer from '@/models/SurveyAnswer';
// Services
import AccentStyleCreator from '@/services/AccentStyleCreator';
import { getCookie, setCookie } from '@/services/CookiesService';
import LogEvent from '@/services/LogEvent';
import SoluCXService from '@/services/SolucxService';
import SoluCXServiceOld from '@/services/SolucxServiceOld';
import Source from '@/services/Source';
import UrlParsedInfo from '@/services/UrlParsedInfo';
import SurveyErrorHandler from '@/Views/SurveyErrorHandler';
// Views
import CompleteView from '@/Views/CompleteView.vue';
import DigitalForm from '@/Views/DigitalForm.vue';
import ErrorView from '@/Views/ErrorView.vue';
import LoadingView from '@/Views/LoadingView.vue';
import PendingView from '@/Views/PendingView.vue';
import { debounceFn } from 'debounce-decorator-ts';
import Timer from 'tiny-timer';
// Core
import EnrichmentData from '@/models/interfaces/EnrichmentData';
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import TemporalCountService from '@/services/TemporalCountService';
import Indicators, { Rating } from '@solucx/indicators';

/**
 * Classe principal da aplicação Survey.
 * Esta classe faz as requisições com a API e controla o estado da aplicação
 */
@Component({
  components: {
    CustomStyle,
    PrivacyLinks,
    DigitalForm,
    SoluCXFooter,
    ErrorView,
    CompleteView,
    PendingView,
    LoadingView,
    SandBox,
    Error,
    Enrichment,
    PreEnrichment,
    ProgressTimer,
  },
})
export default class Digital extends Vue {
  // TODO: deixar o white-mode como injetável universal

  // Injectable  properties ---------------------------------------------------------

  @Inject()
  public readonly soluCXServiceOld: SoluCXServiceOld;

  @Inject()
  public readonly soluCXService: SoluCXService;

  @Inject()
  public readonly temporalCountService: TemporalCountService;

  @Inject()
  public readonly logEvent: LogEvent;

  @Inject()
  public readonly urlParsedInfo: UrlParsedInfo;

  // Status --------------------------------------------------------------------------

  /** Estado da aplicação */
  public state: SurveyState = SurveyState.loading;
  public surveyRequestError: string = '';
  public surveyResponseError: string = null;
  public surveyDateError: string = null;
  public surveyFormError: string = '';
  public statusIntervalVerifier: number = null;

  /** Pré Enriquecimento */
  public preEnrichmentVisible: boolean = false;
  public preEnrichmentError: boolean = false;
  public preEnrichmentLoading: boolean = false;

  // ---------------------------------------------------------------------------------

  /** Avaliação da pesquisa */
  public rating: SurveyAnswer = null;

  /** Parametros da Jornada */
  public parameters: JourneyParameters = null;

  /** Dados da Instância */
  public instance: Instance = null;

  /** Classes a serem avalidas  */
  public evaluationItems: ClassItem[] = [];

  // ---------------------------------------------------------------------------------

  /** Resposta da submissão da avaliação */
  public ratingResponse: RatingSubmitResponse = null;

  // local handlers
  public partialSubmissionTimeout: any = null;
  /** Envio final já pedido: a partir daqui as parciais não são mais enviadas */
  public isSubmitRequested: boolean = false;
  public logSubmissionTimeout: any = null;

  // timers
  public autoSubmitTimer: Timer;
  public timeOutTimer: Timer;
  public timerProgress: number = null;
  public allowPointer: boolean = true;
  public autoSubmitTimerTicks: number = 15000;
  public timeOutTimerTicks: number = 60000;

  // Tablet
  public isTabletStandby: boolean = true;
  public pendingTabletInfo: any = null;
  public avalRef: any = '';
  public isLockScroll: boolean = true;
  public timeoutThanksScreen: number = 3000;

  // ---------------------------------------

  public sending: boolean = false;
  public sandbox: boolean = true;
  public tabletActive: boolean = false;

  public errorVisibility: boolean = false;

  public redirectQueryStringObject: RedirectQueryStringObject = {
    transactionId: '',
    attemptId: '',
    storeId: '',
    document: '',
    email: '',
    phone: '',
    rating: null,
    journeyId: null,
    journeyName: '',
    score: null,
  };

  public customer: Customer = {
    email: '',
    document: '',
    phone: '',
  };

  public SurveyStateObject = SurveyState;
  private cookieQuarentinePrefix: string = 'alreadyAnswered_';

  /**
   * initialize application
   */
  public async created() {
    this.autoSubmitTimer = new Timer({ stopwatch: true });
    this.autoSubmitTimer.on('done', (e) => (this.submitSurvey(this.rating), (this.allowPointer = false)));

    this.timeOutTimer = new Timer({ stopwatch: true });
    this.timeOutTimer.on('done', (e) => this.sendEmptyAvaliacao());

    this.resetState();

    if (this.$route.name === 'tablet') {
      await this.getConfigTablePending();
    }
  }

  private verificationImageWasLoaded(): boolean {
    const img = document.getElementById('x1') as HTMLImageElement;
    return img?.complete === true && img?.naturalHeight === 1;
  }

  public applyCookieQuarantine(): boolean {
    const journey: string = this.getJourneyId();
    const hasCookie: boolean = getCookie(`${this.cookieQuarentinePrefix}${journey}`) === journey;
    return Boolean(hasCookie && this.parameters.enableCookieQuarantine);
  }

  public validateCookieQuarantine(): boolean {
    return (this.rating.isBlockedByCookieQuarantine = this.applyCookieQuarantine() ?? false);
  }

  public async sendEmptyAvaliacao() {
    if (this.$route.name === 'tablet' && !this.parameters?.showSendButton) {
      await this.soluCXService.postTabletStatus(this.rating.employeeId, this.rating.storeId, false, true);
      this.isTabletStandby = true;
    }

    if (this.$route.name === 'totem' && !this.parameters?.showSendButton) {
      location.reload();
    }
  }

  public async checkStatus(): Promise<void> {
    if (this.isTabletStandby === true) {
      this.soluCXService.cancelTabletStatusRequest();
      const tabletStatus: TabletStatus = await this.soluCXService.getTabletStatus(
        this.rating.employeeId,
        this.rating.storeId,
        true,
      );
      if (tabletStatus.show_rating === true && tabletStatus.aval_ref !== null) {
        this.avalRef = tabletStatus.aval_ref;
        /* Se existir show_rating & aval_ref, verifica se tem Attempt para liberar a avaliação */
        const r = await this.soluCXServiceOld.getNewSurveyConfiguration(
          this.rating.employeeId,
          this.rating.storeId,
          this.avalRef,
        );
        if (!r.errors) {
          this.isTabletStandby = false;
        }
      }
    }
  }

  public getUrlParsedInfo(): UrlParsedInfo {
    return {
      attemptId: this.rating.attemptId,
      store_id: this.rating.storeId,
      employee_id: this.rating.employeeId,
      transactionId: this.rating.transactionId,
      apitoken: this.urlParsedInfo.apitoken,
      mode: this.urlParsedInfo.mode,
      source: this.urlParsedInfo.source,
      gender: this.urlParsedInfo.gender,
      birth_date: this.urlParsedInfo.birth_date,
      rating: this.urlParsedInfo.rating,
      journey_id: this.urlParsedInfo.journey_id,
      journey: this.urlParsedInfo.journey,
      cpf: this.urlParsedInfo?.cpf,
      email: this.urlParsedInfo?.email,
    } as UrlParsedInfo;
  }

  public async resetState() {
    if (this.$route.name === 'totem') {
      this.timeOutTimer.stop();
    }

    this.isSubmitRequested = false;

    // Set sandbox
    this.sandbox = this.urlParsedInfo.sandbox;
    // create survey response object
    this.rating = new SurveyAnswer(
      this.urlParsedInfo.transactionId || this.urlParsedInfo.transaction_id,
      this.urlParsedInfo.attemptId,
      this.urlParsedInfo.store_id,
      this.urlParsedInfo.employee_id,
      this.urlParsedInfo.rating,
    );

    // set source
    this.rating.source = this.urlParsedInfo.source;

    try {
      let survey: SurveySettings = null;
      const objUrlParsedInfo = this.getUrlParsedInfo();
      this.changeState(SurveyState.loading);

      // Loads configuration
      switch (this.$route.name) {
        case 'totem':
          if (this.urlParsedInfo.store_id && !this.urlParsedInfo.employee_id) {
            survey = await this.soluCXService.getSurveySettings(objUrlParsedInfo);
          } else {
            objUrlParsedInfo.name = 'cliente';
            objUrlParsedInfo.source = Source.tablet;
            objUrlParsedInfo.template = 'false';
            objUrlParsedInfo.rating = '-1';
            objUrlParsedInfo.amount = '0';

            survey = await this.soluCXService.getSurveySettings(objUrlParsedInfo);
          }
          break;

        case 'tablet':
          // Primeiro checa o status Depois carrega o form
          if (this.isTabletStandby === false) {
            objUrlParsedInfo.aval_ref = this.avalRef;
            objUrlParsedInfo.source = Source.tablet;
            objUrlParsedInfo.template = 'false';

            survey = await this.soluCXService.getSurveySettings(objUrlParsedInfo);
          } else {
            await this.getConfigTablePending();
          }
          break;

        default:
          if (this.rating.attemptId) {
            objUrlParsedInfo.transactionId = this.rating.transactionId;
            objUrlParsedInfo.attemptId = this.rating.attemptId;
            objUrlParsedInfo.journey_id = this.urlParsedInfo.journey_id;
            objUrlParsedInfo.journey = this.urlParsedInfo.journey;
            objUrlParsedInfo.score = this.urlParsedInfo.rating;
            objUrlParsedInfo.template = 'false';
            this.overrideJourney(objUrlParsedInfo);

            survey = await this.soluCXService.getSurveySettings(objUrlParsedInfo);
          } else {
            delete this.urlParsedInfo.overrideJourney;
            survey = await this.soluCXService.getSurveySettings(this.urlParsedInfo);
          }
      }

      // envia nota parcial de forma inicial SE tiver score na URL
      if (this.rating.score !== null || this.rating.score !== undefined || this.rating.score !== -1) {
        this.submitInitialPartial(this.rating);
      }

      // Define as propriedades baseadas na configuração lida
      this.instance = survey.instance;
      this.parameters = survey.parameters as JourneyParameters;
      this.rating.journeyParameters = survey.parameters as JourneyParameters;
      this.evaluationItems = survey.classes;

      this.rating.attemptId = survey.attemptId;
      this.rating.transactionId = survey.transactionId;
      this.rating.journeyId = survey.journeyId;
      this.rating.journeyName = survey.journeyName ?? '';
      this.rating.journeyType = survey.journeyType;
      this.rating.storeId = this.rating.storeId ?? survey.storeId;

      if (this.parameters.showClasses) {
        this.rating.setClasses(this.evaluationItems);
      }

      if (this.parameters.preEnrich) {
        if (
          this.parameters.showNameEnrichment ||
          this.parameters.showDocumentEnrichment ||
          this.parameters.showAddressEnrichment ||
          this.parameters.showEntityDocumentEnrichment ||
          this.parameters.showPhoneEnrichment ||
          this.parameters.showGenderEnrichment ||
          this.parameters.showEmailEnrichment ||
          this.parameters.showBirthEnrichment
        ) {
          this.showPreEnrichmentModal();
        }
      }

      // Parâmetros que são desativados no Totem & Tablet por default
      if (this.isTotemOrTablet) {
        this.rating.source = Source.tablet;
        this.parameters.showAnonymous = false;
        this.parameters.showInHouseAds = 'none';
        this.parameters.showMoreThan6Classes = false;
      }

      if (this.urlParsedInfo.template)
        // Read Template
        this.rating.journeyParameters.template = this.urlParsedInfo.template;

      // change state
      if (this.$route.name !== 'tablet') {
        this.changeState(SurveyState.survey);
      }

      // Change Page Title
      if (this.parameters) document.title = this.parameters.surveyTitle || 'Avalie ' + this.parameters.name;

      // force change color
      this.onColorchanged(this.parameters.color, this.parameters.color);

      // log
      this.logEvent.setInstance(survey.instance.slug);
      this.logEvent.start();
    } catch (error) {
      // chage state to error
      this.parameters = error.configApp ? error.configApp : null;
      const logErrorMsg = this.handleErrorMessages(error);

      if (error.evaluationParameters) {
        this.surveyDateError = error.evaluationParameters.mensagem_data;
      }

      if (this.$route.name !== 'tablet') {
        this.changeState(SurveyState.error);
      } else {
        // Preciso que os parametros antigos (pendingTabletInfo.configApp) sejam iguais do modelo de parameter atual
        if (!!this.pendingTabletInfo.configApp === false) {
          this.parameters = { logo: this.pendingTabletInfo.logo_email };
        } else {
          this.parameters = { logo: this.pendingTabletInfo.configApp.logo_email };
        }
        this.changeState(SurveyState.pending);
      }

      this.logEvent.error(logErrorMsg);
    }

    // Register exiting event
    window.onbeforeunload = () => {
      if (this.state !== SurveyState.done) this.logEvent.giveUp();
    };
  }

  public overrideJourney(objUrlParsedInfo: UrlParsedInfo): void {
    if (!!this.urlParsedInfo?.overrideJourney) {
      const { overrideJourney } = this.urlParsedInfo;
      objUrlParsedInfo.overrideJourney = overrideJourney;
    }
  }

  private async submitInitialPartial(surveyAnswer: SurveyAnswer) {
    const isEmail = !surveyAnswer.source || surveyAnswer.source === Source.email;

    await this.delay(5000);

    if (!this.verificationImageWasLoaded()) return;

    if (isEmail && !(await this.temporalCountService.isTemporalValid(surveyAnswer.score))) return;

    await this.submitPartialSurvey(surveyAnswer, 'initial');
  }

  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // TODO: colocar tratamento de erro em outra função/classe
  public handleErrorMessages(error?: any) {
    if (error && error.errors) {
      const errorHandler = new SurveyErrorHandler(error);
      const foundError = errorHandler.handle();
      this.surveyRequestError = foundError.state;
      return foundError.message;
    }
  }

  public async getConfigTablePending() {
    this.pendingTabletInfo = await this.soluCXServiceOld.getJourneyParameters();
  }

  public resetTimers() {
    this.timeOutTimer.stop();
    if (this.timeOutTimer.status === 'stopped' && this.autoSubmitTimer.status !== 'running') {
      this.timeOutTimer.start(this.timeOutTimerTicks, 100);
    }
  }

  public startTimer() {
    // TODO: Refazer os timers usando promesas e debounce
    // in order to start timer
    // shoud be totem or tablet and score and all items must be answered (valid)

    if (this.getSurveyStatus() === SurveyStatus.valid) {
      this.autoSubmitTimer.stop();
      this.timeOutTimer.stop();
      if (this.rating.journeyParameters.classesNotRequired === false) {
        this.autoSubmitTimer.on(
          'tick',
          (e) => (this.timerProgress = e / (Number(this.parameters.autoSendTimeout) / 100)),
        );
        this.autoSubmitTimer.start(
          Number(this.parameters.autoSendTimeout),
          Number(this.parameters.autoSendTimeout) * 0.02,
        );
      } else {
        this.autoSubmitTimer.on('tick', (e) => (this.timerProgress = e / 150));
        this.autoSubmitTimer.start(this.autoSubmitTimerTicks, 100);
      }

      this.timeOutTimer.start(this.timeOutTimerTicks, 100);
    }
  }

  public logLinkEvent() {
    if (this.logEvent) this.logEvent.link();
  }

  public getSurveyStatus(): SurveyStatus {
    if (this.isTotemOrTablet) return this.rating.getSurveyStatusTotem();
    return this.rating.getSurveyStatus();
  }

  public get privacyLinks() {
    return this.parameters?.privacyLinks || [];
  }

  public get ratingByIndicator(): Rating {
    const indicator = Indicators.getIndicator(this.rating.journeyType);
    return indicator.getRating(this.rating.score);
  }

  /**
   * Check if survey response is valid. and notifies user
   */
  public validateSurveyResponse(survey: SurveyAnswer) {
    const status: SurveyStatus = this.getSurveyStatus();

    if (status !== SurveyStatus.valid) {
      this.logEvent.validation(status);
      this.surveyFormError = this.setErrorMessage();
      this.errorVisibility = true;
      return false;
    }
    return true;
  }

  public setErrorMessage(): string {
    const isCSAT5: boolean = this.parameters.inputType.includes('csat5') || this.parameters.inputType === 'csat';
    const isCES: boolean = this.parameters.inputType.includes('ces');

    const status: SurveyStatus = this.getSurveyStatus();

    if (status === SurveyStatus.scoreMissing) {
      if (isCSAT5) return this.$tc('errorMessages.missingScoreCSAT');
      else if (isCES) return this.$tc('errorMessages.missingScoreCES');
      else return this.$tc('errorMessages.missingScore');
    }

    if (status === SurveyStatus.itemsMissing) {
      return this.$tc('errorMessages.missingItem');
    }
  }

  /**
   * Change app state
   * @arguments state destination state
   */
  public changeState(state: SurveyState) {
    this.state = state;
  }

  // Post ----------------------------------------------------

  /**
   * Partial survey response submission
   */
  @debounceFn(500, 'submitPartialSurveyTimeout')
  public async submitPartialSurvey(survey: SurveyAnswer, trigger: string = 'null'): Promise<void> {
    // parcial concorrente com o envio final pode sobrescrever a avaliação completa
    if (this.isSubmitRequested) return;
    // parcial agendada antes de um reset (totem/tablet) pertence à pesquisa anterior
    if (survey !== this.rating) return;
    if (!this.parameters?.saveInitialRating) return;
    this.validateCookieQuarantine();
    try {
      await this.soluCXService.postPartialSurvey(survey, {}, trigger);
      this.logEvent.partial(survey.score);
    } catch (e) {
      // partial não pega erros
    }
  }

  private isTransientError(error: any): boolean {
    return !error?.response || error.response.status >= 500;
  }

  private async postSurveyRatingWithRetry(survey: SurveyAnswer): Promise<RatingSubmitResponse> {
    try {
      return await this.soluCXService.postSurveyRating(survey);
    } catch (error) {
      if (!this.isTransientError(error)) throw error;
      await this.delay(500);
      return await this.soluCXService.postSurveyRating(survey);
    }
  }

  public getJourneyId(): string {
    return this.rating?.journeyId?.toString();
  }

  /**
   * survey response submission request (submit click or auto submit)
   * marks the request right away, so no partial is sent from here on
   */
  public submitSurvey(survey: SurveyAnswer): void {
    this.isSubmitRequested = true;
    this.sendSurvey(survey);
  }

  /**
   * survey response submission
   */
  @debounceFn(500, 'sendSurveyTimeout')
  public async sendSurvey(survey: SurveyAnswer): Promise<void> {
    // validate form
    if (!this.validateSurveyResponse(survey)) {
      this.isSubmitRequested = false;
      return;
    }
    // clear partial submittion timeout
    if (this.partialSubmissionTimeout) clearTimeout(this.partialSubmissionTimeout);

    this.logEvent.complete();

    // do the submission
    try {
      // change state
      this.sending = true;

      if (!this.rating?.isBlockedByCookieQuarantine) {
        this.validateCookieQuarantine();
      }

      try {
        survey.isBlockedByCookieQuarantine = this.rating?.isBlockedByCookieQuarantine ?? false;
        this.ratingResponse = await this.postSurveyRatingWithRetry(survey);
      } catch (error) {
        if (this.isTransientError(error)) {
          this.surveyFormError = this.$tc('errorMessages.unexpectedErrorDetails');
          this.errorVisibility = true;
          this.logEvent.error(error);
          this.sending = false;
          this.allowPointer = true;
          return;
        }
        this.handleErrorMessages(error);
      }

      if (this.parameters?.enableCookieQuarantine) {
        const domain: string = window.location.hostname === 'localhost' ? 'localhost' : '.solucx.com.br';
        const journey: string = this.getJourneyId();
        setCookie(`${this.cookieQuarentinePrefix}${journey}`, journey, 1, domain);
      }

      // submit survey response (before askinf for enrichment)
      switch (this.$route.name) {
        case 'totem':
          this.allowPointer = true;
          // TODO: Verificar que cria várias transações
          if (!this.hasEnrichment) {
            setTimeout(() => {
              this.resetState();
            }, 3000);
          }
          break;
        case 'tablet':
          await this.soluCXService.postTabletStatus(survey.employeeId, survey.storeId, false, true);
          this.allowPointer = true;
          // TODO: Verificar que cria várias transações
          if (!this.hasEnrichment) {
            setTimeout(() => {
              this.isTabletStandby = true;
            }, 3000);
          }
          break;
        default:
          this.allowPointer = false;
      }

      this.timerProgress = null;

      // check if enrichment (after submiting survey response) and post enrichment
      if (!this.parameters.preEnrich && !survey.anonymous) {
        if (
          this.parameters.showNameEnrichment ||
          this.parameters.showAddressEnrichment ||
          this.parameters.showEntityDocumentEnrichment ||
          this.parameters.showGenderEnrichment ||
          this.parameters.showEmailEnrichment ||
          this.parameters.showPhoneEnrichment ||
          this.parameters.showDocumentEnrichment ||
          this.parameters.showBirthEnrichment
        ) {
          // o resolve retorna o valor da variavel
          const enrichmentParameters = await (this.$refs.enrichment as any).askForEnrichmentParameter();
          if (enrichmentParameters) {
            await this.soluCXService.postEnrichment({
              name: enrichmentParameters.name,
              email: enrichmentParameters.email,
              phone: enrichmentParameters.phone,
              address: enrichmentParameters.address,
              gender: enrichmentParameters.gender,
              cpf: enrichmentParameters.cpf,
              birth: enrichmentParameters.birth,
              consents: enrichmentParameters.consents,
              transactionId: parseInt(this.rating.transactionId),
              attemptId: parseInt(this.rating.attemptId),
            });

            this.customer = {
              email: enrichmentParameters.email,
              document: enrichmentParameters.cpf,
              phone: enrichmentParameters.phone,
            };

            this.mountRedirectQueryStringObject();

            this.logEvent.enrichment();
          } else {
            this.logEvent.enrichment(false);
          }
        }
      }
      // Go to success page if no redirec url
    } catch (error) {
      // chage state to error
      this.surveyResponseError = error;
      this.handleErrorMessages(error?.response?.data);
      this.changeState(SurveyState.error);
      this.logEvent.error(error);
    }

    this.finishSurvey();
    this.sending = false;
  }

  public finishSurvey(): void {
    const directRedirect: boolean = !!this.parameters?.completedUrlRedirection && !this.parameters?.showThanksScreen;
    const isTotem: boolean = this.$route.name === 'totem';
    const isTablet: boolean = this.$route.name === 'tablet';

    this.logEvent.done();
    if (directRedirect) this.redirectToCompletedUrl();
    else {
      if (this.parameters?.showThanksScreen) this.changeState(SurveyState.done);
      if (isTotem && this.hasEnrichment) this.finishTotem();
      else if (isTablet && this.hasEnrichment) this.finishTablet();
      else this.finishURL();
    }
  }

  public finishTotem(): void {
    const hasRedirectURL: boolean = !!this.parameters.completedUrlRedirection;
    setTimeout(() => {
      if (hasRedirectURL) this.redirectToCompletedUrl();
      else this.resetState();
    }, 3000);
  }

  public finishTablet(): void {
    this.timeoutThanksScreen = Number(this.parameters.timeoutToThanksScreen) || this.timeoutThanksScreen;

    setTimeout(() => {
      this.isTabletStandby = true;
    }, this.timeoutThanksScreen);
  }

  public finishURL(): void {
    const hasRedirectURL: boolean = !!this.parameters?.completedUrlRedirection;
    if (hasRedirectURL) {
      setTimeout(() => {
        this.redirectToCompletedUrl();
      }, 3000);
    }
  }

  public redirectToCompletedUrl() {
    this.mountRedirectQueryStringObject();
    window.location.href = this.replaceUrlVariablesToData(this.parameters.completedUrlRedirection);
  }

  public replaceUrlVariablesToData(url: string): string {
    let newUrl = url;
    Object.keys(this.redirectQueryStringObject).map((key) => {
      if (newUrl.includes(`{${key}}`)) {
        newUrl = newUrl.replace(`{${key}}`, this.redirectQueryStringObject[key]);
      }
    });

    return newUrl;
  }

  public hasEnrichment(): boolean {
    if (
      this.parameters.showEmailEnrichment ||
      this.parameters.showPhoneEnrichment ||
      this.parameters.showDocumentEnrichment ||
      this.parameters.showBirthEnrichment
    ) {
      return true;
    } else {
      return false;
    }
  }

  public closeError(state: boolean) {
    this.errorVisibility = state;
  }

  public mountRedirectQueryStringObject(): void {
    this.redirectQueryStringObject = {
      transactionId: this.rating.transactionId,
      attemptId: this.rating.attemptId,
      storeId: this.rating.storeId,
      document: this.customer.document,
      email: this.customer.email,
      phone: this.customer.phone,
      rating: this.ratingByIndicator,
      score: this.rating.score,
      journeyId: this.rating.journeyId,
      journeyName: encodeURIComponent(this.rating.journeyName ?? ''),
    };
  }

  public async showPreEnrichmentModal() {
    this.preEnrichmentVisible = true;
  }
  public async hidePreEnrichmentModal() {
    this.preEnrichmentVisible = false;
  }

  public async preEnrichmentComplete(enrichmentParameters: EnrichmentData) {
    this.changeState(SurveyState.survey);

    if (enrichmentParameters) {
      try {
        this.preEnrichmentLoading = true;
        this.preEnrichmentError = false;
        await this.soluCXService.postEnrichment({
          name: enrichmentParameters.name,
          email: enrichmentParameters.email,
          phone: enrichmentParameters.phone,
          cpf: enrichmentParameters.cpf,
          address: enrichmentParameters.address,
          gender: enrichmentParameters.gender,
          birth: enrichmentParameters.birth,
          consents: enrichmentParameters.consents,
          transactionId: parseInt(this.rating.transactionId),
          attemptId: parseInt(this.rating.attemptId),
        });
        this.customer = {
          email: enrichmentParameters.email,
          document: enrichmentParameters.cpf,
          phone: enrichmentParameters.phone,
        };

        this.hidePreEnrichmentModal();

        this.mountRedirectQueryStringObject();

        this.logEvent.enrichment();
      } catch (e) {
        console.error('Error on sending enrichment. ', e);
        this.preEnrichmentError = true;
      }

      this.preEnrichmentLoading = false;
    } else {
      this.logEvent.enrichment(false);
    }
  }

  // Getters  ----------------------------------------------------

  public get isTablet(): boolean {
    return this.$route.name === 'tablet';
  }

  public get isTotemOrTablet(): boolean {
    return this.$route.name === 'tablet' || this.$route.name === 'totem';
  }

  public get isStateError(): boolean {
    return this.state === SurveyState.error;
  }

  public get showFooter(): boolean {
    return !this.isStateError && !this.parameters?.hideCredits;
  }

  // Watchers ----------------------------------------------------

  /**
   * Change lockScroll Watch
   */
  @Watch('parameters.lockScroll')
  public onLockScrollChanged(val: boolean) {
    if (val === null) {
      this.isLockScroll = this.isTotemOrTablet;
    } else {
      this.isLockScroll = val;
    }
  }

  /**
   * Change Accent color Watch
   */
  @Watch('parameters.color')
  public onColorchanged(val: string, old: string) {
    AccentStyleCreator.createAccentColorStyle(val);
  }

  @Watch('rating.score', { immediate: true })
  public onSurveyScoreChanged(val: number) {
    clearTimeout(this.logSubmissionTimeout);
    this.logSubmissionTimeout = setTimeout(() => {
      if (this.logEvent && val != null) this.logEvent.rate(val);
    }, 300);
  }

  @Watch('rating.comment')
  public onSurveyCommentChanged(val: string) {
    if (this.logEvent && val != null && val !== '') this.logEvent.comment();
  }

  @Watch('rating.anonym')
  public onSurveyAnonymChanged(val: boolean) {
    if (this.logEvent && val != null) this.rating.anonymous = val;
    this.logEvent.anonym(val);
  }

  @Watch('rating.items', { immediate: true })
  public onSurveyClassesChanged(val: ClassItemRate[]) {
    if (val === undefined) return;
    for (const item of val) if (item.like === null) return;
    if (this.logEvent && val !== undefined) this.logEvent.items();
  }

  @Watch('rating.items')
  public surveyItemsWatch(items: ClassItemRate[], oldVal: ClassItemRate[]) {
    if (this.isTotemOrTablet) {
      for (const item of items) {
        if (item.like !== null) this.resetTimers();
      }
    }

    /** se showSendButton = false
    Não exibir botão (inclusive no digital)
    Ligar Time-out de envio automático (inclusive no digital) */

    if (this.parameters && !this.parameters.showSendButton) {
      this.startTimer();
    }
  }

  @Watch('rating.score')
  public surveyScoreWatch(val: number) {
    if (this.isTotemOrTablet) {
      if (val !== null) this.resetTimers();
    }

    /** se showSendButton = false
    Não exibir botão (inclusive no digital)
    Ligar Time-out de envio automático (inclusive no digital) */

    if (this.parameters && !this.parameters.showSendButton) {
      this.startTimer();
    }
  }

  @Watch('isTabletStandby', { immediate: true })
  public isTabletStandbyWatch(val: boolean) {
    if (this.$route.name === 'tablet') {
      this.changeState(SurveyState.pending);
      if (val) {
        this.statusIntervalVerifier = window.setInterval(() => {
          this.checkStatus();
          if (!this.isTabletStandby) window.clearInterval(this.statusIntervalVerifier);
        }, 5000);
      } else {
        this.resetState();
        this.changeState(SurveyState.survey);
        this.timeOutTimer.start(this.timeOutTimerTicks, 100);
      }
    }
  }
}
